import * as auth from '../_redux/authRedux';
import { Avatar, TextField, Link, Typography } from '@material-ui/core';
import { Button, Alert } from 'rsuite';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import loginService from '../../../services/login';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

export function Login (props) {
    const history = useHistory();
    // State

    const [isLoading, setIsLoading] = useState(false);
    const [account, setAccount] = useState('');
    const [password, setPassword] = useState('');

    // Events

    const toForgot = () => {
        history.push('/auth/forgot');
    };

    const login = async (event) => {
        try {
            event.preventDefault();
            setIsLoading(true);

            if (!account || !password) {
                Alert.warning('Debes completar los datos para poder iniciar sesión.');
                setIsLoading(false);
                return false;
            }

            const user = await loginService.login(account, password);

            setIsLoading(false);

            localStorage.setItem('sessionUser', JSON.stringify(user));
            return props.login(user.token.access_token);
        }
        catch (error) {
            setIsLoading(false);
            if (error.response?.data?.extra?.key === 'user_blocked') {
                return Alert.warning('Su usuario se ha bloqueado.', 7000);
            }
            if (error.response?.data?.extra?.key === 'password_blocked') {
                return Alert.warning('Su contraseña se ha bloqueado.', 7000);
            }
            if ([400, 401, 404].includes(error.response.status)) {
                return Alert.warning('Las credenciales ingresadas son incorrectas.', 7000);
            }
            Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 7000);
        }
    };

    return (
        <div className='auth-page'>
            <Avatar>
                <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Iniciar Sesión
            </Typography>
            <form noValidate onSubmit={login}>
                <TextField
                    id="account"
                    label="Email"
                    name="account"
                    variant="outlined"
                    autoFocus fullWidth
                    onChange={(event) => setAccount(event.target.value)}
                />
                <TextField
                    id="password"
                    label="Contraseña"
                    name="password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    onChange={(event) => setPassword(event.target.value)}
                />
                <Button type="submit" appearance='primary' block disabled={isLoading}>
                    Iniciar Sesión
                </Button>
            </form>
            <Link variant="body2" onClick={toForgot}>
                Olvide mi contraseña
            </Link>
        </div>
    );
};

export default injectIntl(connect(null, auth.actions)(Login));
